import * as React from 'react'
import { useSideBars } from 'src/modules/Routing/hooks/sideBars/useSideBars';
import { RoutesModules } from 'src/modules/Routing/types';
import NavigationLink from './NavigationLink';
import { isSidebarActive } from '../hooks/useIsRouteActive';

interface INavigationSidebarLinksProps {
  sidebarModule: RoutesModules;
}

const NavigationSidebarLinks = ({ sidebarModule }: INavigationSidebarLinksProps) => {
  const [routes] = useSideBars(sidebarModule);
  const isActive = isSidebarActive();
  return (
    <>
      {routes.map((sidebar, i) => {
        const navigationLink =
          <NavigationLink
            key={i}
            isActive={isActive(sidebar.route, sidebar.path, sidebar.isMainPath, sidebar.modulePath)}
            filterPath={sidebar.path}
            routePath={sidebar.route}
            navTitle={sidebar.navTitle}
            isSidebar={true}
          />
        return (
          !sidebar.isFormLink ?
            navigationLink :
            <div key={i} className="notification-links">{navigationLink}</div>
        )
      })}
    </>
  );
}

export default React.memo(NavigationSidebarLinks);



// WEBPACK FOOTER //
// ./src/modules/Navigation/NavBar/components/NavigationSidebarLinks.tsx